import OrdersActionsMenu from './OrdersActionsMenu';

export default OrdersActionsMenu;
